var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49992 16.5C5.12766 16.5 1.58325 13.1421 1.58325 9C1.58325 4.85786 5.12766 1.5 9.49992 1.5C13.8721 1.5 17.4166 4.85786 17.4166 9C17.4166 13.1421 13.8721 16.5 9.49992 16.5ZM8.70825 11.25V12.75H10.2916V11.25H8.70825ZM10.2916 10.0163C11.4361 9.6936 12.2708 8.68913 12.2708 7.5C12.2708 6.05025 11.0302 4.875 9.49992 4.875C8.15567 4.875 7.03496 5.78189 6.78237 6.9851L8.33522 7.27933C8.44352 6.76367 8.92382 6.375 9.49992 6.375C10.1557 6.375 10.6874 6.87868 10.6874 7.5C10.6874 8.1213 10.1557 8.625 9.49992 8.625C9.06268 8.625 8.70825 8.96077 8.70825 9.375V10.5H10.2916V10.0163Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon_question.221bb64d1c23b5b7bf3af1f9a9c718e9.svg";
export { ForwardRef as ReactComponent };